var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lucide/info"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.49992 10.6673L8.49992 7.50049M8.49992 5.33398H8.50659M15.1666 8.00065C15.1666 11.6826 12.1818 14.6673 8.49992 14.6673C4.81802 14.6673 1.83325 11.6826 1.83325 8.00065C1.83325 4.31875 4.81802 1.33398 8.49992 1.33398C12.1818 1.33398 15.1666 4.31875 15.1666 8.00065Z",
    stroke: "#575BE8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.00ed98715f6f3020a2a5e9f6d643ace3.svg";
export { ForwardRef as ReactComponent };